import { ProdOrderState } from '@app/core/models/prod-order-state.enum';

export class ProdOrderStateHelper {
  public static postReleased(stateId: number): boolean {
    switch (stateId) {
      case ProdOrderState.Started:
      case ProdOrderState.Stopped:
      case ProdOrderState.Reported:
      case ProdOrderState.Completed:
      case ProdOrderState.Closed:
      case ProdOrderState.Archived:
      case ProdOrderState.Canceled:
        return true;
      default:
        return false;
    }
  }

  public static isEditable(stateId: number): boolean {
    switch (stateId) {
      case ProdOrderState.Planned:
      case ProdOrderState.Preview:
        return true;
      default:
        return false;
    }
  }

  public static postPlanned(stateId: number): boolean {
    switch (stateId) {
      case ProdOrderState.Released:
      case ProdOrderState.Started:
      case ProdOrderState.Stopped:
      case ProdOrderState.Reported:
      case ProdOrderState.Completed:
      case ProdOrderState.Closed:
      case ProdOrderState.Archived:
      case ProdOrderState.Canceled:
        return true;
      default:
        return false;
    }
  }
}
